<template>
    <div>
        <label for="paises">{{ $t('formularios.pais') }}</label>
        <ValidationProvider name="paises" id="paises" rules="required" v-slot="{ errors }">
            <multiselect
                :disabled="desactivar"
                v-model="selected"
                :placeholder="$t('formularios.pais')"
                label="nombre"
                track-by="id"
                :options="paises"
                :multiple="false"
                v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
            />
            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
        </ValidationProvider>
    </div>
</template>

<script>

    export default {
        props: {
            pais: {
                type: Object,
                default: null
            },
            desactivar: {
                type: Boolean,
                default: false
            },
            errors: {
                type: Array,
                default: () => []
            }

        },
        data() {
            return {
                paises: [],
                selected: null
            }
        },
        created() {
            this.getPaises();

            if(this.pais) {
                this.selected = this.pais;
            }
        },
        computed: {
        },
        methods: {
            getPaises() {
                this.$store.dispatch(this.config.getVuexAlias('select.paises')).then(res => {
                    this.paises = res.data.data;

                    if(this.pais) {
                        this.selected = this.pais;
                    } else {
                        this.selected = this.paises[67];
                    }

                    this.$emit('rellenarPais', this.selected)
                    this.$emit('paisesCargados', this.paises);
                });
            }
        }
    }
</script>
